<div class="login-page-wrapper">
    <h1 class="main-heading">Vendor Login</h1>
    <div class="alert alert-info py-2 text-center" role="status"><strong>Demo mode</strong> — credentials are pre-filled; use OTP <strong>1234</strong>.</div>
    
    <form [formGroup]="loginForm" (ngSubmit)="onSubmitForm($event)" class="form-container">
        <div class="fields-container">
            <div class="mb-3 email-section">
                <label for="email" class="email-label form-label font-weight-bold">Email</label>
                <input type="email" class="email-inpute form-control" id="email" formControlName="Email"
                    placeholder="Enter your Email">
                <div *ngIf="loginForm.get('Email')?.invalid && (loginForm.get('Email')?.dirty || loginForm.get('Email')?.touched)"
                    class="text-danger">
                    <small *ngIf="loginForm.get('Email')?.errors?.['required']">Email is required.</small>
                    <small *ngIf="loginForm.get('Email')?.errors?.['email']">Enter a valid email.</small>
                    <small *ngIf="loginForm.get('Email')?.errors?.['custom']">{{ loginForm.get('Email')?.errors?.['custom']
                        }}</small>
                </div>
            </div>
            <div class="mb-3 password-section">
                <label for="password" class="password-label form-label">Password</label>
                <div class="password-input-wrapper">
                    <input [type]="showPassword ? 'text' : 'password'" class="password-inpute form-control" id="password"
                        formControlName="Password" placeholder="Enter your Password">
                    <i class="fas password-toggle-icon" 
                       [class.fa-eye]="!showPassword" 
                       [class.fa-eye-slash]="showPassword"
                       (click)="togglePasswordVisibility()"></i>
                </div>
                <div *ngIf="loginForm.get('Password')?.invalid && (loginForm.get('Password')?.dirty || loginForm.get('Password')?.touched)"
                    class="text-danger">
                    <small *ngIf="loginForm.get('Password')?.errors?.['required']">Password is required.</small>
                    <small *ngIf="loginForm.get('Password')?.errors?.['minlength']">Password must be at least 6 characters
                        long.</small>
                    <small *ngIf="loginForm.get('Password')?.errors?.['custom']">{{
                        loginForm.get('Password')?.errors?.['custom'] }}</small>
                </div>
            </div>
            <div class="submition d-flex justify-content-center">
                <button type="submit" class="submit-btn btn btn-primary">Sign In</button>
            </div>

            <div class="forgot-password mt-3 d-flex justify-content-center">
                <a [routerLink]="['/', AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.FORGET_EMAIL]"
                    class="forgot-password-link text-decoration-none">Forget Password?</a>
            </div>
            <div class="create-acc mt-3 d-flex justify-content-center">
                <span class="dont-have-account" style="margin-right: 10px;">Don't have an account? </span>
                <a [routerLink]="['/', AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.RegisterVendor]"
                    class="create-account-link">Create account</a>
            </div>
        </div>
    </form>
</div>
